/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InvoiceMonthSummaryItem { 
    /**
     * Month (1-12)
     */
    month: number;
    /**
     * Date range start (YYYY/MM/DD)
     */
    dateRangeStart: string;
    /**
     * Date range end (YYYY/MM/DD)
     */
    dateRangeEnd: string;
    /**
     * Total amount in cents (can be negative)
     */
    totalAmountCents: number;
    /**
     * Currency
     */
    currency: string;
    /**
     * Invoice status
     */
    status: string;
}

